import ApiService from "../../services/apiService";
import { useAuth } from "../../hooks/useAuth";
import { useEffect, useState, useCallback, useMemo } from "react";
import Loader from "../../elements/Loader";
import Pagination from "../../elements/Pagination";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { debounce } from "lodash";

const Task = () => {
    const { role } = useAuth();
    const [task, setTask] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const getTask = useCallback(() => {
        setLoading(true);
        let url = `task/${role}?page=${currentPage + 1}&limit=10`;
        if (searchTerm) url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
        ApiService.get(url).then((result) => {
            setLoading(false)
            setPageCount(result.totalPages)
            // Convert updatedAt to IST before setting booking data
            const taskWithIST = result.data.map((dp) => ({
                ...dp,
                updatedAt: convertToIST(dp.updatedAt),
                createdAt: convertToIST(dp.createdAt),
            }));
            setTask(taskWithIST)
        }).catch((error) => {
            console.log(error)
            setLoading(false)
        })
    }, [role, currentPage, searchTerm]);

    const debouncedSearch = useMemo(() => debounce((val) => {
        setCurrentPage(0);
    }, 500), []);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        debouncedSearch(e.target.value);
    };
    console.log("Page Count:", pageCount);

    const convertToIST = (utcDate) => {
        const date = new Date(utcDate);
        return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
    };

    useEffect(() => {
        getTask()
    }, [getTask])

    const handlePageClick = (selectedPage) => {
        const clickedPage = selectedPage.selected;
        if (clickedPage !== currentPage) {
            setCurrentPage(clickedPage);
        }
    }

    const taskCompleted = async (bookingId, type) => {
        const userConfirmed = window.confirm("Are you sure you want to take this action?");
        if (userConfirmed) {
            ApiService.post('task', { bookingId, type, bookingStatus: 'samagri_delivered' }).then((result) => {
                if (result.msg === 'success') {
                    toast.success('Task Marked as Completed')
                }
                getTask()
            }).catch((err) => {
                console.log(err)
                toast.error('something wrong!')
            })
        } else {
            // Cancel the action
            console.log("Action canceled!");
        }

    }
    useEffect(() => {
        const interval = setInterval(() => {
              window.location.reload(); // Refresh the page
          }, 5 * 60 * 1000); // 5 minutes in milliseconds
    
          return () => clearInterval(interval); // Cleanup interval on component unmount
      }, []);
    return (
        <div className="row">
            <div className="col-xl-12">
                {loading && <Loader />}
                <div className="card dz-card" id="bootstrap-table2">
                    <div className="card-header flex-wrap d-flex justify-content-between border-0">
                        <div>
                            <h4 className="card-title">Task List</h4>
                        </div>
                        <div className="input-group search-area" style={{ width: '250px' }}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by name, puja, booking ID..."
                                value={searchTerm}
                                onChange={handleSearch}
                            />
                            <span className="input-group-text">
                                <i className="flaticon-381-search-2"></i>
                            </span>
                        </div>
                    </div>
                    {/* tab-content */}

                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-responsive-md">
                                <thead>
                                    <tr>
                                        <th>
                                            <strong>TaskID</strong>
                                        </th>
                                        <th>
                                            <strong>Customer Name</strong>
                                        </th>
                                        <th>
                                            <strong>Puja Name</strong>
                                        </th>
                                        <th>
                                            <strong>Booking Id</strong>
                                        </th>

                                        <th>
                                            <strong>Task Type</strong>
                                        </th>
                                        <th>
                                            <strong>Status</strong>
                                        </th>
                                        <th>
                                            <strong>Created At</strong>
                                        </th>
                                        <th>
                                            <strong>Updated At</strong>
                                        </th>
                                        <th>
                                            <strong>Action</strong>
                                        </th>
                                        <th>
                                            <strong>Address</strong>
                                        </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {task && task?.length > 0 && task.map((dp, key) => {
                                        return (
                                            <tr>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <span className="w-space-no">{dp.taskId}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="w-space-no">{dp?.booking?.user?.name || '—'}</span>
                                                </td>
                                                <td>
                                                    <span className="w-space-no">{dp?.booking?.service?.title || '—'}</span>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <span className="w-space-no">
                                                            {role !== 'logistic' ? (
                                                                <Link to={`/edit-booking/${dp.bookingId}`} className="text-blue-500">
                                                                    <span className="d-none d-md-inline">{dp.bookingId}</span>
                                                                    <span className="d-inline d-md-none">...{dp.bookingId?.slice(-4)}</span>
                                                                </Link>
                                                            ) : (
                                                                <>
                                                                    <span className="d-none d-md-inline">{dp.bookingId}</span>
                                                                    <span className="d-inline d-md-none">...{dp.bookingId?.slice(-4)}</span>
                                                                </>
                                                            )}
                                                        </span>
                                                    </div>
                                                </td>


                                                <td>
                                                    <div className="d-flex align-items-center">

                                                        <span className="w-space-no">{dp?.type}</span>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="d-flex align-items-center">

                                                        <span className="w-space-no">{dp?.status}</span>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="d-flex align-items-center">

                                                        <span className="w-space-no">{dp?.createdAt}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">

                                                        <span className="w-space-no">{dp?.updatedAt}</span>
                                                    </div>
                                                </td>
                                                
                                                <td>
                                                    {(role === 'logistic' || role === 'superadmin' || role === 'admin') &&
                                                    dp.status !== 'done' &&
                                                    dp.status !== 'cancelled' &&
                                                    dp.type === 'samagri_deliver' && (
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => {
                                                                if (!dp?.booking?.address?.fullAddress) {
                                                                    toast.error('Please add the address before samagri deliver');
                                                                    return;
                                                                }
                                                                taskCompleted(dp.bookingId, 'samagri_deliver');
                                                            }}
                                                        >
                                                            Mark as completed
                                                        </button>
                                                    )}
                                                </td>
                                                <td>
                                                    {((role === 'logistic' || role === 'superadmin' || role === 'admin') &&
                                                        dp.type === 'samagri_deliver' ) && (
                                                        <div>
                                                            <div className="d-flex align-items-center">

                                                                <span className="w-space-no">{dp?.booking?.address?.fullAddress}</span>
                                                            </div>
                                                            <div className="d-flex align-items-center">

                                                                <span className="w-space-no">{dp?.booking?.address?.locality}</span>
                                                            </div>
                                                            <div className="d-flex align-items-center">

                                                                <span className="w-space-no">{dp?.booking?.address?.direction}</span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </td>

                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>

                            <Pagination pageCount={pageCount} handlePageClick={handlePageClick} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Task;